import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

export default function Rate({ iconSrc, value }) {
  return (
    <Col className="text-center">
      <img src={iconSrc} width="64" height="64" alt="Rate Emoji" />
      <div className="mt-1 fw-semibold">
        {value}
        %
      </div>
    </Col>
  );
}

Rate.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  value: PropTypes.number,
};

Rate.defaultProps = {
  value: 0,
};
